import { useQuery } from '@tanstack/react-query';
import * as api from './api';

const ROOT_KEY = 'states';

export function useStateOptions() {
  return useQuery({
    queryKey: [ROOT_KEY, 'options'] as const,
    queryFn: () => api.getStateOptions(),
    // States change ~never; cache aggressively.
    staleTime: 60 * 60 * 1000,
  });
}
